import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import snake1 from '../../backgroundImages/snake1.webp';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <motion.div 
      className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="max-w-md w-full text-center space-y-6">
        {/* 404 Display */}
        <motion.div 
          className="flex items-center justify-center gap-2 sm:gap-4"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, type: "spring", stiffness: 200 }}
        >
          <span className="text-6xl sm:text-8xl font-bold text-foreground">4</span>
          <motion.img
            src={snake1}
            alt="Snake"
            className="w-20 h-20 sm:w-28 sm:h-28 rounded-full object-cover shadow-lg border-4 border-white"
            initial={{ rotate: -10 }}
            animate={{ rotate: [0, -5, 5, 0] }}
            transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
          />
          <span className="text-6xl sm:text-8xl font-bold text-foreground">4</span>
        </motion.div>

        {/* Title */}
        <motion.h1 
          className="text-xl sm:text-2xl font-semibold text-foreground"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          {t('page_not_found', 'Page Not Found')}
        </motion.h1>

        {/* Subtitle */}
        <motion.p 
          className="text-sm sm:text-base text-muted-foreground"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {t('page_not_found_desc', "The page you're looking for doesn't exist or has been moved.")}
        </motion.p>

        {/* Actions */}
        <motion.div 
          className="flex flex-col sm:flex-row gap-3 justify-center pt-4"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="h-11 px-6"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t("back", "Go Back")}
          </Button>
          <Button
            onClick={() => navigate('/')}
            className="h-11 px-6"
          >
            <Home className="w-4 h-4 mr-2" />
            {t("home", "Home")}
          </Button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default NotFoundPage;